import { Component } from '@angular/core';
import { ManagePermissionsComponent } from './manage-permissions/manage-permissions.component';

@Component({
  selector: 'app-admin',
  standalone: true,
  imports: [ManagePermissionsComponent],
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.css'
})
export class AdminComponent {

}
